// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Agenda_DeletarCompromissoResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for /agenda/deletar_compromisso
 *
 * NON-CANON endpoint: Deletes a compromisso (appointment) from the agenda.
 * Returns success status as a primitive boolean.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Agenda_DeletarCompromissoResponseDados = boolean;

export type Agenda_DeletarCompromissoResponse = ApiResponse<Agenda_DeletarCompromissoResponseDados>;

registerResponseContract('Agenda_DeletarCompromissoResponse', {})
